import {
	getNodeDetail,
	getNodeHistoryDetailByVersion,
	getStructureDetailV1,
} from '@/endpoints'
import { mapStructureMetadataToStructureDetailDto } from '@/endpoints/mapStructureMetadataToDetail'
import { HistoryDetailDto, StructureDetailDto } from '@/endpoints/models'
import { apiCallAction } from '@/store/utils'

import { NODE_LOAD, NODE_LOAD_HISTORY_VERSION } from './constants'

export interface LoadNode {
	payload: StructureDetailDto
	type: typeof NODE_LOAD
}

export interface LoadNodeHistoryVersion {
	payload: HistoryDetailDto
	type: typeof NODE_LOAD_HISTORY_VERSION
}

/**
 * V1 `GET structure/{id}` supplies `data`, `workingData`, and the full legacy DTO.
 * V2 `GET v2/structure/{id}` metadata overrides ACL when the call succeeds.
 */
export const loadNode = (id: number) => {
	return apiCallAction<LoadNode>(
		() => async (token) => {
			const full = await getStructureDetailV1(id)(token)

			try {
				const metadata = await getNodeDetail(id)(token)
				const acl = mapStructureMetadataToStructureDetailDto(metadata)
				return {
					...full,
					canEdit: acl.canEdit,
					structurePermissions: acl.structurePermissions,
					lockUserId: acl.lockUserId,
					lockUserName: acl.lockUserName,
					lockTime: acl.lockTime,
					orderPriority: acl.orderPriority ?? full.orderPriority,
					status: acl.status ?? full.status,
				}
			} catch {
				return full
			}
		},
		NODE_LOAD,
	)
}

export const loadNodeHistoryVersion = (
	id: number,
	version: number,
	envId?: number,
) =>
	apiCallAction<LoadNodeHistoryVersion>(
		() => getNodeHistoryDetailByVersion(id, version, { envId }),
		NODE_LOAD_HISTORY_VERSION,
	)
